import DashboardLayout from "@/views/Layout/DashboardLayout";

const section = { render: (h) => h("router-view") };

function page(path, name, component, props = {}) {
  return { path, name, component, props: { active: true, ...props }, meta: { groupName: "Library", hideFooter: true } };
}

export default {
  path: "/library",
  component: DashboardLayout,
  meta: {
    requiresAuth: true,
    allowedRoles: ["superadmin", "superadmin2"],
  },
  children: [
    {
      path: "",
      component: () => import("@/library/LibraryLayout.vue"),
      children: [
        { path: "", redirect: "catalog" },
        page("catalog", "LibraryCatalog", () => import("@/library/ecatalog/ECatalog.vue")),
        {
          path: "homrog",
          component: section,
          children: [
            page("", "LibraryBooks", () => import("@/library/homrog/BookRegister.vue")),
            page("inventory", "LibraryInventory", () => import("@/library/homrog/InventoryRegister.vue")),
            page("paper-catalog", "LibraryPaperCatalog", () => import("@/library/homrog/PaperCatalog.vue")),
            page("import", "LibraryImport", () => import("@/library/homrog/ImportRegister.vue")),
          ],
        },
        page("readers", "LibraryReaders", () => import("@/library/unshigch/ReaderRegister.vue")),
        {
          path: "service",
          component: section,
          children: [
            page("", "LibraryService", () => import("@/library/uilchilgee/ServiceScreen.vue")),
            page("loans", "LibraryLoans", () => import("@/library/uilchilgee/LoanList.vue")),
            page("extensions", "LibraryExtensions", () => import("@/library/uilchilgee/ExtensionList.vue")),
          ],
        },
        {
          path: "reports",
          component: section,
          children: [
            page("", "LibraryReports", () => import("@/library/tailan/ReportScreen.vue")),
            page("charts", "LibraryCharts", () => import("@/library/tailan/ChartScreen.vue")),
          ],
        },
        {
          path: "settings",
          component: section,
          children: [
            page("", "LibraryHistory", () => import("@/library/config/HistoryRegister.vue")),
            page("content-groups", "LibraryContentGroups", () => import("@/library/config/ContentGroupRegister.vue")),
            page("account-types", "LibraryAccountTypes", () => import("@/library/config/AccountTypeRegister.vue")),
            page("documents", "LibraryDocuments", () => import("@/library/config/DocumentRegister.vue")),
            page("classifications", "LibraryClassifications", () => import("@/library/config/ClassificationRegister.vue")),
            page("reader-groups", "LibraryReaderGroups", () => import("@/library/config/SimpleListRegister.vue"), { kind: "readerGroups" }),
            page("languages", "LibraryLanguages", () => import("@/library/config/SimpleListRegister.vue"), { kind: "languages" }),
            page("cities", "LibraryCities", () => import("@/library/config/SimpleListRegister.vue"), { kind: "cities" }),
            page("publishers", "LibraryPublishers", () => import("@/library/config/SimpleListRegister.vue"), { kind: "publishers" }),
            page("rooms", "LibraryRooms", () => import("@/library/config/SimpleListRegister.vue"), { kind: "rooms" }),
          ],
        },
      ],
    },
  ],
};
